export default "__VITE_ASSET__03a84b89__"